import * as types from './actionTypes';

export function stockDummySet(stock: any, isComplete: Boolean) {
  return { type: types.STOCK_DUMMY_SET, stock, isComplete };
}
